import memoize from '../../../common/utils/memoize';
import * as screensReducer from '../reducers/screens';

const getScreen = (state, id) => state.academy.screens.items[id];

export const item = memoize.createItemSelector(
  [getScreen],
  (state, screen) => screen && screensReducer.findById(state, screen.id),
);
